import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { FormModeProvider } from '../../base/contexts/FormModeContext'
import Loadable from '../../base/components/Template/Loadable/Loadable'
import { ProductoInputProps } from './interfaces/producto.interface'
import {
  ProductoFormMode,
  productoFormModeDefault,
  productoFormModelConfig,
} from './services/productoFormMode'
import { productosRouteMap } from './ProductosRoutesMap'

const AppProductosGestion = Loadable(lazy(() => import('./view/Productos')))
const AppProductoNuevo = Loadable(lazy(() => import('./view/ProductoRegistro')))
const AppProductoActualizar = Loadable(lazy(() => import('./view/ProductoActualizar')))

const productosRoutes = [
  {
    path: productosRouteMap.gestion.path,
    element: <AppProductosGestion />,
    auth: authRoles.admin,
  },
  {
    path: productosRouteMap.nuevo.path,
    element: (
      <FormModeProvider<ProductoInputProps, ProductoFormMode>
        mode={'create'}
        config={productoFormModelConfig}
        defaults={productoFormModeDefault}
      >
        <AppProductoNuevo />
      </FormModeProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: `${productosRouteMap.modificar.path}/:id`,
    element: (
      <FormModeProvider<ProductoInputProps, ProductoFormMode>
        mode={'edit'}
        config={productoFormModelConfig}
        defaults={productoFormModeDefault}
      >
        <AppProductoActualizar />
      </FormModeProvider>
    ),
    auth: authRoles.admin,
  },
]

export default productosRoutes
